import { render } from "./QueryPage.vue?vue&type=template&id=cb2d25ca&scoped=true"
import script from "./QueryPage.vue?vue&type=script&lang=js"
export * from "./QueryPage.vue?vue&type=script&lang=js"

import "./QueryPage.vue?vue&type=style&index=0&id=cb2d25ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2d25ca"]])

export default __exports__